define(["require", "exports", "vue-color", "vue"], function (require, exports, vue_color_1, vue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ColorPickerComponent = (function () {
        function ColorPickerComponent() {
            vue_1.default.component('colorpicker', {
                components: {
                    'chrome-picker': vue_color_1.Chrome,
                },
                template: "\n        <div class=\"input-group color-picker\" ref=\"colorpicker\">\n            <input type=\"text\" class=\"form-control\" v-model=\"color\" @focus=\"showPicker\" />\n            <span class=\"input-group-addon color-picker-container\">\n                <span class=\"current-color\" :style=\"'background-color: ' + color\" @click=\"togglePicker\"></span>\n                <chrome-picker :disableAlpha=\"disableAlpha\" :value=\"colors\" @input=\"updateFromPicker\" v-if=\"displayPicker\" />\n            </span>\n        </div>",
                props: {
                    value: String,
                    disableAlpha: {
                        type: Boolean,
                        default: false
                    }
                },
                data: function () {
                    return {
                        displayPicker: false,
                        tmp_color: this.value,
                    };
                },
                methods: {
                    showPicker: function () {
                        document.addEventListener('click', this.documentClick);
                        this.displayPicker = true;
                    },
                    hidePicker: function () {
                        document.removeEventListener('click', this.documentClick);
                        this.displayPicker = false;
                    },
                    togglePicker: function () {
                        this.displayPicker ? this.hidePicker() : this.showPicker();
                    },
                    updateFromPicker: function (color) {
                        if (color.rgba.a == 1) {
                            this.color = color.hex;
                        }
                        else {
                            this.color = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
                        }
                    },
                    documentClick: function (e) {
                        var el = this.$refs.colorpicker, target = e.target;
                        if (el !== target && !el.contains(target)) {
                            this.hidePicker();
                        }
                    }
                },
                computed: {
                    colors: function () {
                        console.log("colors");
                        if (this.value.slice(0, 1) == '#') {
                            return {
                                hex: this.value
                            };
                        }
                        else if (this.value.slice(0, 4) == 'rgba') {
                            var rgba = this.value.replace(/^rgba?\(|\s+|\)$/g, '').split(','), hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
                            return {
                                hex: hex,
                                a: rgba[3],
                            };
                        }
                    },
                    color: {
                        get: function () {
                            return this.tmp_color;
                        },
                        set: function (color) {
                            this.tmp_color = color;
                            this.$emit('input', color);
                        }
                    }
                }
            });
        }
        return ColorPickerComponent;
    }());
    exports.ColorPickerComponent = ColorPickerComponent;
});
//# sourceMappingURL=ColorPickerComponent.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Components/ColorPickerComponent.js
// module id = 397
// module chunks = 0